import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import Phone from '@/components/Device/Phone';
import Default from '@/components/Device/Default';
import Bad from '@/components/Device/Bad';

import getSystemInfo from '@/utils/getSystemInfo';
import Log from '@/components/Log';

import './style.less';

export enum justifyContent {
  left = 'left',
  center = 'center',
  right = 'right'
}

interface IDevice {
  type?: string;
  data?: object;
  events?: any;
  activeType?: any
  justifyContent?: justifyContent
}

@Component
export default class Device extends tsx.Component<IDevice> {
  
  @Prop() public type?: string;
  @Prop() public data?: object;
  @Prop() public events?: any;
  @Prop() public activeType?: any;
  @Prop() public justifyContent?: justifyContent
  
  mounted () {
  }
  
  render() {
    const {events, data, activeType, justifyContent } = this.$props;
    return (
      <div class='device-container' style={`height:${getSystemInfo().deviceSize.defaultHeight}px;`}>
        {this.$props.type === '2' ?
          <Log number='H001'><Default justifyContent={justifyContent} data={data} activeType={activeType} events={events}/></Log>
          :
          (
            data.status === 0 ?
              <Bad justifyContent={justifyContent} data={data} activeType={activeType} events={events}/> :
              <Phone justifyContent={justifyContent} data={data} events={events} activeType={activeType} />
          )
        }
      </div>
    )
  }
  
}